import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import GaodeMap from 'vue-amap'
import VueAxios from 'vue-axios';
import axios from 'axios';
Vue.prototype.$axios = axios;

Vue.use(VueAxios, axios)

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(GaodeMap);

GaodeMap.initAMapApiLoader({
  key: 'f1ba7f009dce9e41a458b5ef355996fd',
  v:'1.4.4'
});

// 格式化时间
import moment from 'moment'
Vue.prototype.$moment = moment

Vue.filter('dateformat', function (dataStr, pattern = 'YYYY-MM-DD') {
  return moment(dataStr).format(pattern)
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

window.onload = function(){
  function setRem(){
      var uiw = 1920;
      var winw = document.documentElement.clientWidth || document.body.clientWidth;
      document.documentElement.style.fontSize = (winw / uiw) * 100 +'px';
  }
  setRem();
  window.onresize = setRem;
}
